import pillarArticle from "./pillarArticle";
import clusterArticles1 from "./clusterArticles1";
import clusterArticles2 from "./clusterArticles2";
import clusterArticles3 from "./clusterArticles3";
import pillarPflegebegleitung from "./pillarPflegebegleitung";
import clusterPflegebegleitung from "./clusterPflegebegleitung";
import clusterNeueArtikel2026 from "./clusterNeueArtikel2026";
import clusterBeratungsthemen2026 from "./clusterBeratungsthemen2026";

const allArticles = [pillarArticle, ...clusterArticles1, ...clusterArticles2, ...clusterArticles3, pillarPflegebegleitung, ...clusterPflegebegleitung, ...clusterNeueArtikel2026, ...clusterBeratungsthemen2026];

export function getAllArticles() {
  return allArticles;
}

export function getArticleBySlug(slug) {
  return allArticles.find((a) => a.slug === slug) || null;
}
